var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMobileDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.75H1.75V1.25H8V6.875V7.5H8.625H14.25V18.75ZM9.25 1.45703L14.043 6.25H9.25V1.45703ZM9.5625 0H1.75H0.5V1.25V18.75V20H1.75H14.25H15.5V18.75V5.9375L9.5625 0ZM4.875 10H4.25V11.25H4.875H11.125H11.75V10H11.125H4.875ZM4.875 12.5H4.25V13.75H4.875H11.125H11.75V12.5H11.125H4.875ZM4.875 15H4.25V16.25H4.875H11.125H11.75V15H11.125H4.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMobileDocs);
export default __webpack_public_path__ + "static/media/nav-mobile-docs.ee0c8eedd0a840ab56d0273badd5d7e6.svg";
export { ForwardRef as ReactComponent };